import React, { SVGProps } from "react";

const SvgProtrusion01Dims = (props: SVGProps<SVGSVGElement>) => (
  <svg
    width={350}
    height={300}
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    viewBox="0 0 350 300"
    {...props}
  >
    <path
      d="M142.288 200.89v74.625l172.434-99.757v-74.625L142.288 200.89Z"
      fill="#B2C4D0"
    />
    <path
      d="M142.29 200.891v74.625L29.538 107.576l112.752 93.315Z"
      fill="#fff"
    />
    <path
      d="M29.538 107.576 153.41 217.689l179.052-103.576L211.753 4 29.538 107.576Z"
      fill="#309DD6"
    />
    <path
      d="M197.583 201.563v33.238l28.33-16.39v-33.238l-28.33 16.39ZM231.845 181.802v33.236l28.331-16.39v-33.236l-28.331 16.39Z"
      fill="#255D63"
    />
    <path
      d="M314.724 124.374v51.384L142.29 275.516 29.538 107.576"
      stroke="#3F3F3F"
      strokeWidth={2}
      strokeLinejoin="round"
    />
    <path d="M142.288 274.224v-66.419" stroke="#3F3F3F" />
    <path
      d="M29.538 107.576 211.753 4l120.709 110.113L153.41 217.689 29.538 107.576Z"
      stroke="#00232D"
      strokeWidth={2}
      strokeLinejoin="round"
    />
    <path
      d="m114.984 291.949 21.331-12.317M2 226.926l21.28-12.363M7.402 224.042l112.219 64.58M175.599 294.46l-26.655-15.389M342.848 192.136 170.4 291.457M347.999 195.016 321.68 179.82"
      stroke="#3B3B3B"
      strokeWidth={1.5}
      strokeLinecap="round"
    />
    <path
      d="M139.806 180.403h3.376c.725 0 1.322.101 1.792.304.48.203.858.459 1.136.768.288.309.485.656.592 1.04.117.384.176.757.176 1.12 0 .533-.091 1.003-.272 1.408a2.912 2.912 0 0 1-.752 1.024 3.3 3.3 0 0 1-1.152.608 4.74 4.74 0 0 1-1.44.208h-1.936v4.192h-1.52v-10.672Zm3.44 5.168c.661 0 1.168-.165 1.52-.496.362-.341.544-.811.544-1.408 0-.608-.187-1.083-.56-1.424-.363-.352-.864-.528-1.504-.528h-1.92v3.856h1.92Z"
      fill="#fff"
    />
    <path
      d="M263.398 242.142h3.616c.554 0 1.034.075 1.44.224.405.139.741.331 1.008.576.266.246.464.534.592.864.138.331.208.683.208 1.056 0 .342-.059.646-.176.912a2.917 2.917 0 0 1-.432.704 2.167 2.167 0 0 1-.576.464c-.203.118-.39.192-.56.224.213.032.453.102.72.208.266.096.517.246.752.448.234.203.432.47.592.8.16.32.24.72.24 1.2 0 .576-.107 1.056-.32 1.44a2.48 2.48 0 0 1-.848.912c-.352.235-.774.4-1.264.496a8.167 8.167 0 0 1-1.568.144h-3.424v-10.672Zm3.344 9.344c.277 0 .565-.016.864-.048.298-.032.57-.106.816-.224a1.54 1.54 0 0 0 .624-.512c.16-.234.24-.554.24-.96 0-.384-.08-.693-.24-.928a1.673 1.673 0 0 0-.592-.56 2.162 2.162 0 0 0-.784-.272 4.604 4.604 0 0 0-.832-.08h-1.952v3.584h1.856Zm.048-4.896c.234 0 .469-.026.704-.08.234-.064.448-.16.64-.288a1.48 1.48 0 0 0 .464-.496c.117-.202.176-.448.176-.736 0-.32-.059-.576-.176-.768a1.223 1.223 0 0 0-.464-.464 1.646 1.646 0 0 0-.64-.224 3.999 3.999 0 0 0-.704-.064h-1.904v3.12h1.904ZM54.504 260.301h1.568l4.176 10.672h-1.712l-1.104-2.976h-4.384l-1.104 2.976h-1.616l4.176-10.672Zm2.464 6.4-1.728-4.688-1.744 4.688h3.472Z"
      fill="#3B3B3B"
    />
    <path
      d="M7.186 219.074v9.685M120.127 284.223v9.685M170.398 286.626v9.684M343.03 187.046v9.685"
      stroke="#3B3B3B"
      strokeWidth={1.5}
      strokeLinecap="round"
    />
    <path
      d="m141.068 171.958-94.237-54.372M140.35 166.478l-8.396 4.842M137.156 198.693l-9.692.144M135.936 169.012a128.62 128.62 0 0 1-1.022 16.862 103.334 103.334 0 0 1-2.51 13.025"
      stroke="#fff"
      strokeWidth={1.5}
      strokeLinecap="round"
    />
    <path d="M29.538 210.955v-2.421" stroke="#00232D" strokeLinejoin="round" />
    <path
      d="M29.538 203.814v-82.591"
      stroke="#00232D"
      strokeLinejoin="round"
      strokeDasharray="3.9 3.9"
    />
    <path
      d="M29.538 118.863v-2.421M35.99 214.352l2.1 1.208"
      stroke="#00232D"
      strokeLinejoin="round"
    />
    <path
      d="m42.424 218.053 84.481 48.597"
      stroke="#00232D"
      strokeLinejoin="round"
      strokeDasharray="4.13 4.13"
    />
    <path
      d="m129.072 267.897 2.1 1.208"
      stroke="#00232D"
      strokeLinejoin="round"
    />
  </svg>
);

export default SvgProtrusion01Dims;
